import { useContext } from 'react';
import { FocusedThreadIdContext } from '../components/FocusedThreadIdProvider';
export const useFocusedThreadId = () => useContext(FocusedThreadIdContext);